import { Type } from 'class-transformer';
import { Arteh } from './Arteh';
import { Lager } from './Lager';

export class OffeneBestellung {
    public belegnummer: number;
    @Type(() => Date)
    public belegdatum: Date;
    @Type(() => Lager)
    public lager: Lager;
    @Type(() => Arteh)
    public arteh: Arteh;
    public menge: number;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/OffeneBestellung.ts